module.exports = __webpack_public_path__ + "img/img_introduction_02.e45f3c95.png";